import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';

import {DataService} from "../services/data.service";
import {ApiService} from "../services/api.service";
import {Setting} from "../type/setting";

@Component({
    selector: 'app-setting-add',
    templateUrl: './setting-add.component.html',
    styleUrls: ['./setting-add.component.css']
})
export class SettingAddComponent implements OnInit {

    node = 'setting';
    setting: Setting = Setting;

    constructor(private dataService: DataService,
                private apiService: ApiService,
                private location: Location) {
    }

    ngOnInit() {
        this.dataService.refresh();
    }

    onFormSubmit(formData) {
        var data = {
            setting_name : formData.value.setting_name,
            setting_code : formData.value.setting_code,
            setting_value : formData.value.setting_value
        }
        this.apiService.postNew(this.node, data)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: Setting added successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/settings/setting-add.component.ts